{
  "toast": {
    "companyCreated": "Company créé",
    "storeCreated": "Store créé",
    "warehouseCreated": "Warehouse créé",
    "workCalendarConfigured": "Work calendar configurerd",
    "departmentCreated": "Department créé",
    "enterpriseSetupComplete": "Enterprise setup complete",
    "onboardingCompleted": "Onboarding terminé",
    "productCreated": "Product créé",
    "customerCreated": "Customer créé",
    "productsSaved": "Products enregistré"
  },
  "errors": {
    "createOrSelectAWeekPattern": "Create ou sélectionner a week pattern",
    "failedToCreateCompany": "Échec de la création de company",
    "failedToCreateStore": "Échec de la création de store",
    "failedToCreateWarehouse": "Échec de la création de warehouse",
    "failedToLoadWeekPatterns": "Échec du chargement de week patterns",
    "failedToSaveCalendar": "Échec de l'enregistrement de calendar",
    "failedToCreateDepartment": "Échec de la création de department",
    "unableToCompleteOnboardingPleaseReviewDetailsAnd": "Unable à complete onboarding. Please review details et retry.",
    "storeNameAndCodeAreRequired": "Magasin name et code are requis",
    "productNameIsRequired": "Produit name is requis",
    "customerNameIsRequired": "Client name is requis",
    "failedToCreateProduct": "Échec de la création de product",
    "failedToCreateCustomer": "Échec de la création de customer",
    "selectAtLeastOneProductToContinue": "Sélectionnez au moins un product to continue",
    "couldNotSaveYourProductSelectionPleaseTry": "Impossible de save your product selection. Please try again."
  },
  "pages": {
    "enterpriseSetup": "Enterprise setup",
    "organizationCompanyStoreWarehouseCalendarHr": "Organization → Company → Magasin → Entrepôt → Calendar → HR → Finance → Go Live",
    "setUpPointOfSale": "Set up Point of Sale",
    "completeTheseStepsToStartSelling": "Complete these steps à start selling"
  },
  "labels": {
    "companyName": "Company name",
    "code": "Code",
    "storeName": "Magasin name",
    "storeCode": "Magasin code",
    "warehouseName": "Entrepôt name",
    "warehouseCode": "Entrepôt code",
    "assignWeekPattern": "Assign week pattern",
    "departmentName": "Département name",
    "departmentCode": "Département code",
    "organizationName": "Organization name",
    "organizationType": "Organization type",
    "industry": "Industry",
    "logoUrl": "Logo URL",
    "themeMode": "Theme mode",
    "productName": "Produit name",
    "sku": "SKU",
    "price": "Price",
    "customerName": "Client name",
    "phone": "Phone"
  },
  "listActions": {
    "openPosTerminal": "Ouvrir le terminal PDV"
  }
}
